import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Tous les éléments de bloc sont aplatis en inline pour que le line-clamp CSS
// s'applique sur un flux de texte continu.
//
// react-markdown est en v5 dans ce projet : l'API est `renderers` + `plugins`,
// et les clés sont des noms de noeuds mdast (`paragraph`, `link`, `list`…), pas
// des balises HTML. Les `components` de la v6 seraient ignorés en silence, donc
// le texte ressortirait en blocs et le line-clamp ne verrait qu'une ligne.
const inlineRenderers = {
  paragraph: ({ children }) => <span>{children} </span>,
  link: ({ children, href }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#4e73df" }}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </a>
  ),
  list: ({ children }) => <span>{children}</span>,
  listItem: ({ children }) => <span>• {children} </span>,
  heading: ({ children }) => <span>{children} </span>,
  blockquote: ({ children }) => <span>{children} </span>,
};

/**
 * Rend un texte Markdown (gras, liens, listes…) PUIS le crope via CSS
 * (-webkit-line-clamp) — jamais l'inverse : couper la chaîne avant
 * interprétation laisse des `**` bruts quand la troncature tombe au
 * milieu d'une syntaxe.
 *
 * Pattern de référence : TaskCard.js (SectorsManagement), "Line 3 - Description".
 */
const ClampedMarkdown = ({ children, lines = 2, className, style }) => {
  if (!children) return null;
  return (
    <div
      className={className}
      style={{
        display: "-webkit-box",
        WebkitLineClamp: lines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        ...style,
      }}
    >
      <ReactMarkdown plugins={[remarkGfm]} renderers={inlineRenderers}>
        {children}
      </ReactMarkdown>
    </div>
  );
};

export default ClampedMarkdown;
